const hpCatProducts = () => {
    const intervalId = setInterval(isProducts, 100)

    function isProducts() {
        const productImages = document.querySelectorAll('.products-carousel__inner .product img')

        if (productImages.length > 0) {
            clearInterval(intervalId)

            productImages.forEach((img) => {
                img.src = img.getAttribute('data-src')
            })
        }
    }
}

const expeditionAvailabilityHp = () => {
    const codes = document.querySelectorAll('.product [data-micro="sku"]')

    if (codes) {
        let codesArr = []

        for (const [i, code] of codes.entries()) {
            let pCode = code.textContent

            if (i === codes.length - 1) {
                const codeString = `[]=${pCode}`
                codesArr.push(codeString)
            } else {
                const codeString = `[]=${pCode}&codes`
                codesArr.push(codeString)
            }
        }

        const finalQuerry = codesArr.join('')

        const url = `https://aplikace.mimedigital.cz/supporting-endpoints.happy-zoo/?codes${finalQuerry}`

        const xhr = new XMLHttpRequest()
        xhr.open('GET', url)

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                const productStocks = JSON.parse(xhr.responseText)

                const products = document.querySelectorAll('.product')

                if (products) {
                    for (const product of products) {
                        const pCode = product.querySelector('[data-micro="sku"]')?.textContent

                        for (const item of Object.entries(productStocks)) {
                            const itemCode = item[1].code
                            const stockId = item[1].stock.id
                            const stockQty = item[1].amount

                            if (itemCode === pCode && stockId === 1 && stockQty > 0) {
                                product.querySelector(
                                    '.availability span:not(.availability-amount)'
                                ).textContent = 'skladem ihned k expedici'
                            }
                        }
                    }
                }
            }
        }

        xhr.send()
    }
}

$(document).ready(function () {
    const isIndex = document.querySelector('.type-index')

    if (isIndex) {
        hpCatProducts()
        expeditionAvailabilityHp()

        document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
            expeditionAvailabilityHp()
        })
    }
})
